<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Treatment After Microscopy
      </h2>
      <p class="tw-italic tw-text-gray-700">
        
      </p>
    </b-container>

    <b-container fluid>
      <b-row>
      <b-col lg="4"></b-col>
      <b-col lg="4"></b-col>
      <b-col lg="4">
        <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <br />
      </b-col>
    </b-row>
    </b-container>

    <hr>
    
    <b-card no-body>
        <b-tabs card fill>
          <b-tab :title="'NEEDS TO BE PACKAGED ('+packaged.length+')'" active>
            <b-card-text >
              <b-table striped hover :fields="fields" :items="packaged" :filter="filter" :tbody-tr-class="'clickable'" @row-clicked="rowClicked">

              </b-table>
            </b-card-text>
          </b-tab>

          <b-tab :title="'NEEDS TO BE DELIVERED ('+delivered.length+')'">
            <b-card-text >
              <b-table striped hover :fields="fields" :items="delivered" :filter="filter" :tbody-tr-class="'clickable'" @row-clicked="rowClicked">
                
              </b-table>
            </b-card-text>
          </b-tab>

          <b-tab :title="'PACKAGED AND DELIVERED ('+completed.length+')'">
            <b-card-text >
              <b-table striped hover :fields="fields" :items="completed" :filter="filter">
                
              </b-table>
            </b-card-text>
          </b-tab>
        </b-tabs>
    </b-card>
    
    <b-modal :ref="'contact_info_modal'" id="contact_info_modal" size="xl" :title="'Contact Information'" ok-only header-class="border-bottom-0">
      <b-row>
        <b-col class="font-weight-bold col-3">
          <h3>Subject Name:</h3>
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          <h3 class="font-weight-light">{{ selected_subject.subject_case.subject_name }}</h3>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="font-weight-bold col-3">
          Head of Household:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.head_of_household }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold col-3">
          Relation to HoH:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.relation_to_head }}
        </b-col>
      </b-row>

      <b-row>
        <b-col class="font-weight-bold col-3">
          Telephone Number:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.telephone_number }}
        </b-col>
      </b-row>

      <b-row v-if="selected_subject != null && selected_subject.subject_case.second_telephone_number != null">
        <b-col class="font-weight-bold col-3">
          Second Telephone Number:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.second_telephone_number }}
        </b-col>
      </b-row>

      <br />

       <b-row>
        <b-col class="font-weight-bold col-3">
          Consenting Adult:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.subject_consenting_person }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold col-3">
          Consenting Adult Telephone:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.subject_consenting_phone }}
        </b-col>
      </b-row>

      <br />

       <b-row>
        <b-col class="font-weight-bold col-3">
          Head of Structure:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.structure.head_of_structure }}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold col-3">
          Head of Structure Telephone:
        </b-col>
        <b-col v-if="selected_subject != null" style="text-align: left;">
          {{ selected_subject.subject_case.head_of_structure_phone }}
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "subject_id" },
        { key: "date_of_collection" }
      ],
      aesae_list_fields: [
        { key: "date", label: "AE/SAE Date" },
        { key: "is_ae_sae", label: "Type" },
        { key: "status" },
        // { key: "outcome" },
        { key: "ae_sae_id", label: "AE/SAE ID" },
      ],
      packaged: [],
      delivered: [],
      completed: [],
      componentKey: 0,
      filter: null,
      active_aesae_list: [],
      active_aesae_modal_title: 'AE/SAE Cases',
      selected_subject: null
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/treatment-after-microscopy/get_list").then(response => {
      that.packaged = response.data.need_packaged;
      that.delivered = response.data.need_delivery;
      that.completed = response.data.delivered;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('subjectsreferred', 
            ['getSubjectsReferredCount', 'setSubjectsReferredCount']),

    refreshSideNavCount(){
      this.getSubjectsReferredCount().then((response) => {
                this.setSubjectsReferredCount(response.data);
            })
    },
    view_aesae_list: function(index){
      let that = this;
      that.active_aesae_list = that.subjects[index].aesae_list;
      that.active_aesae_modal_title = 'AE/SAE Cases for ' + that.subjects[index].subject_id;
    },

     rowClicked(record, index){
      let that = this;
      that.selected_subject = record;
      this.showModal(index);
    },

    showModal() {
        this.$refs[('contact_info_modal')].show();
      },
    dismiss: function(index){
      let that = this;
      HTTP.post("/kenya/subjects_referred/"+that.subjects[index].id+"/", {
        status: 'dismiss'
      }).then(() => {
          var dismissed_obj = that.subjects.splice(index, 1)[0];
          that.dismissed_subjects.push(dismissed_obj);
          that.refreshSideNavCount();
      });


    }
  }
};
</script>

<style>
.right-text{
  text-align: right;
}
.clickable {
  cursor: pointer;
}
</style>